export const createBlankListing = (listingType = 'rent') => ({
  listingType,
  title: '',
  slug: '',
  status: 'draft',
  featured: false,
  summary: '',
  description: '',
  externalUrl: '',
  sampleWebsite: '',
  mapUrl: '',
  mainImage: '',
  galleryImages: [],
  rentDetails: {
    buildingSize: '',
    propertyType: '',
    propertySubtype: '',
    yearBuilt: '',
    lotSize: '',
    aboutProperty: '',
    propertyOverview: '',
    locationOverview: '',
  },
  propertyDetails: {
    mlsNumber: '',
    mlsType: '',
    propertyType: '',
    originalPrice: '',
    soldPrice: '',
    bedrooms: '',
    bathrooms: '',
    size: '',
    yearBuilt: '',
    lotSize: '',
    hoaFees: '',
    county: '',
    represented: '',
    amenities: {
      accessibilityFeatures: '',
      appliances: '',
      architecturalStyle: '',
      associationFeeIncludes: '',
      constructionMaterials: '',
      cooling: '',
      disclosures: '',
      fireplaceFeatures: '',
      fireplaceYN: '',
      fireplacesTotal: '',
      flooring: '',
      foundationDetails: '',
      garageSpaces: '',
      heating: '',
      laundryFeatures: '',
      levelStreet: '',
      levelUpper: '',
      lotFeatures: '',
      parkingFeatures: '',
      poolFeatures: '',
      poolPrivateYN: '',
      possession: '',
      propertySubtype: '',
      propertyType: '',
      roof: '',
      stories: '',
    },
  },
});

export const rentFields = [
  ['buildingSize', 'Building Size'],
  ['propertyType', 'Property Type'],
  ['propertySubtype', 'Property Subtype'],
  ['yearBuilt', 'Year Built'],
  ['lotSize', 'Lot Size'],
];

export const propertyFields = [
  ['mlsNumber', 'MLS #'],
  ['mlsType', 'MLS Type'],
  ['propertyType', 'Property Type'],
  ['originalPrice', 'Original Price'],
  ['soldPrice', 'Sold Price'],
  ['bedrooms', 'Bedrooms'],
  ['bathrooms', 'Bathrooms'],
  ['size', 'Size'],
  ['yearBuilt', 'Year Built'],
  ['lotSize', 'Lot Size'],
  ['hoaFees', 'HOA Fees'],
  ['county', 'County'],
  ['represented', 'Represented'],
];

export const amenityFields = [
  { key: 'accessibilityFeatures', label: 'Accessibility Features', kind: 'text' },
  { key: 'appliances', label: 'Appliances', kind: 'textarea', rows: 3 },
  { key: 'architecturalStyle', label: 'Architectural Style', kind: 'text' },
  { key: 'associationFeeIncludes', label: 'Association Fee Includes', kind: 'textarea', rows: 3 },
  { key: 'constructionMaterials', label: 'Construction Materials', kind: 'text' },
  { key: 'cooling', label: 'Cooling', kind: 'text' },
  { key: 'disclosures', label: 'Disclosures', kind: 'textarea', rows: 3 },
  { key: 'fireplaceFeatures', label: 'Fireplace Features', kind: 'text' },
  { key: 'fireplaceYN', label: 'Fireplace Y/N', kind: 'select', options: ['Yes', 'No'] },
  { key: 'fireplacesTotal', label: 'Fireplaces Total', kind: 'number', min: 0, step: 1 },
  { key: 'flooring', label: 'Flooring', kind: 'text' },
  { key: 'foundationDetails', label: 'Foundation Details', kind: 'text' },
  { key: 'garageSpaces', label: 'Garage Spaces', kind: 'number', min: 0, step: 1 },
  { key: 'heating', label: 'Heating', kind: 'text' },
  { key: 'laundryFeatures', label: 'Laundry Features', kind: 'text' },
  { key: 'levelStreet', label: 'Level Street', kind: 'text' },
  { key: 'levelUpper', label: 'Level Upper', kind: 'text' },
  { key: 'lotFeatures', label: 'Lot Features', kind: 'text' },
  { key: 'parkingFeatures', label: 'Parking Features', kind: 'textarea', rows: 3 },
  { key: 'poolFeatures', label: 'Pool Features', kind: 'text' },
  { key: 'poolPrivateYN', label: 'Pool Private Y/N', kind: 'select', options: ['Yes', 'No'] },
  { key: 'possession', label: 'Possession', kind: 'text' },
  { key: 'propertySubtype', label: 'Property Subtype', kind: 'text' },
  { key: 'propertyType', label: 'Property Type', kind: 'text' },
  { key: 'roof', label: 'Roof', kind: 'text' },
  { key: 'stories', label: 'Stories', kind: 'number', min: 0, step: 1 },
];
